/** Public acquisition lives on www; login and authenticated work live on app. */
export const WEBSITE_ORIGIN = 'https://www.gramfather.com';
export const APP_ORIGIN = 'https://app.gramfather.com';
export const SIGNUP_URL = WEBSITE_ORIGIN + '/signup';
export const LOGIN_URL = APP_ORIGIN + '/login';

const PUBLIC_SIGNUP_ENDPOINTS = new Set([
  'start', 'recover', 'email', 'status', 'password', 'plan', 'check-code',
  'promo', 'card', 'activate', 'marketing-consent', 'upgrade/view',
]);

/** This exception never grants the website access to authenticated app APIs. */
export function isWebsiteSignupRequest(origin: string | undefined, path: string, method: string): boolean {
  return origin === WEBSITE_ORIGIN && (method === 'POST' || method === 'OPTIONS') &&
    path.startsWith('/api/auth/signup/') && PUBLIC_SIGNUP_ENDPOINTS.has(path.slice('/api/auth/signup/'.length));
}

export function canonicalSignupUrl(search: string, hash = '', storedSession?: string | null): string {
  const url = new URL(SIGNUP_URL);
  url.search = search;
  url.hash = hash;
  // A pre-move 3-D Secure return keeps its session in app sessionStorage.
  if (!url.hash && storedSession) url.hash = new URLSearchParams({ session: storedSession }).toString();
  return url.href;
}
